import { Subdivision, CreateStaff, Staff } from '../../../types/subdivision';
import { ApiAbstract } from '../abstract';

export class ApiSubdivision extends ApiAbstract<any, Subdivision> {}
export class ApiStaff extends ApiAbstract<CreateStaff, Staff> {}
export class ApiUpdateIsKarmaUser extends ApiAbstract<Staff, Subdivision> {}
export class ApiUpdateStatusUser extends ApiAbstract<any, any> {}
